import React from 'react'
import cn from 'classnames'

interface SeparatorProps {
  className?: string
  kind?: 'strong' | 'subtle'
  style?: React.CSSProperties
}

const Separator = ({
  className = '',
  kind = 'subtle',
  style = {},
}: SeparatorProps) => (
  <hr
    className={cn('mc-separator', className, {
      [`mc-separator--${kind}`]: kind,
    })}
    aria-hidden
    style={style}
  />
)

export default Separator
